var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineimg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 226,
    height: 337,
    viewBox: "0 0 226 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.859375 334.596C37.97 312.329 75.0807 275.219 112.191 223.264C149.302 171.309 186.413 97.0873 223.523 0.599609",
    stroke: "#C84B4B",
    strokeWidth: 3.33996
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.192 42.8663C210.549 42.8663 212.459 40.9561 212.459 38.5997C212.459 36.2433 210.549 34.333 208.192 34.333C205.836 34.333 203.926 36.2433 203.926 38.5997C203.926 40.9561 205.836 42.8663 208.192 42.8663Z",
    fill: "url(#paint0_linear_4698_11990)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.126 287.681C65.4825 287.681 67.3927 285.648 67.3927 283.141C67.3927 280.633 65.4825 278.6 63.126 278.6C60.7696 278.6 58.8594 280.633 58.8594 283.141C58.8594 285.648 60.7696 287.681 63.126 287.681Z",
    fill: "url(#paint1_linear_4698_11990)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4698_11990",
    x1: 208.192,
    y1: 34.333,
    x2: 208.192,
    y2: 42.8663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4698_11990",
    x1: 63.126,
    y1: 278.6,
    x2: 63.126,
    y2: 287.681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineimg);
export default __webpack_public_path__ + "static/media/line img.2d93f90ac8d35700e8cfa68b719fc8a3.svg";
export { ForwardRef as ReactComponent };